import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  checkboxIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    background: '#F0F3F7',
    border: '1px solid rgba(34, 64, 96, .2)',
  },
  checkedCheckboxIcon: {
    background: theme.custom.accept,
    borderColor: theme.custom.accept,
  },
  checkIcon: {
    fontSize: '1rem',
    color: '#fff',
  },
  checkboxRoot: {
    padding: 0,
    color: theme.custom.accept,
  },
  colorSecondary: {
    '&.Mui-disabled': {
      opacity: 0.3,
    },
  },
}));
